var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[
        'c mb-2',
        _vm.selectionStatus,
        this.$vuetify.theme.dark ? 'dark' : '' ],attrs:{"type":"button"},on:{"click":_vm.select}},[_vm._v(" "+_vm._s(_vm.course)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }